import {
  Avatar,
  Box,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { LinkedAccountProfile } from "types/auth";

type Props = {
  open: boolean;
  accounts: LinkedAccountProfile[];
  currentUserId?: string;
  loading: boolean;
  switchingUserId?: string | null;
  onClose: () => void;
  onSelect: (account: LinkedAccountProfile) => void;
};

export function SwitchAccountDialog({
  open,
  accounts,
  currentUserId,
  loading,
  switchingUserId,
  onClose,
  onSelect,
}: Props) {
  return (
    <Dialog open={open} onClose={switchingUserId ? undefined : onClose} fullWidth>
      <DialogTitle>Switch account</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box display="flex" justifyContent="center" py={3}>
            <CircularProgress aria-label="Loading linked profiles" />
          </Box>
        ) : (
          <List disablePadding>
            {accounts.map((account) => {
              const current =
                account.current || account.user_id === currentUserId;
              const switching = switchingUserId === account.user_id;
              return (
                <ListItemButton
                  key={account.user_id}
                  disabled={current || Boolean(switchingUserId)}
                  onClick={() => onSelect(account)}
                >
                  <ListItemAvatar>
                    <Avatar
                      src={account.picture_url || undefined}
                      alt={account.name}
                    >
                      {account.name?.[0]}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Box display="flex" gap={1} alignItems="center">
                        <Typography fontWeight={600}>{account.name}</Typography>
                        {current && <Chip size="small" label="Current" />}
                        {switching && <CircularProgress size={16} />}
                      </Box>
                    }
                    secondary={
                      <>
                        <Typography component="span" variant="body2">
                          {account.email}
                        </Typography>
                        <Typography
                          component="span"
                          variant="body2"
                          sx={{ textTransform: "capitalize" }}
                        >
                          {" "}
                          · {account.role}
                        </Typography>
                      </>
                    }
                  />
                </ListItemButton>
              );
            })}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
}
